import { render, staticRenderFns } from "./modulo2.vue?vue&type=template&id=dfd67bd6&scoped=true&"
import script from "./modulo2.vue?vue&type=script&lang=js&"
export * from "./modulo2.vue?vue&type=script&lang=js&"
import style0 from "./modulo2.vue?vue&type=style&index=0&id=dfd67bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd67bd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
